export class UrlHelper {
   public static cleanPath(url: string) {
       return url.replace(Backbone.history.root, "");
   }

   public static replaceSpaces(url: string) {
      return url.replace(new RegExp(this.escapeRegExp(" "), "g"), "-");
   }

   private static  escapeRegExp(str) {
     return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
   }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/url-helpers.ts